import React, { Component } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import AuthContext from '../utils/AuthContext';
import './NavMenu.css';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    render() {
        return (
            <header>
                <AuthContext.Consumer>
                    {data =>
                        data.loggedIn ?
                            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light>
                                <NavbarBrand tag={Link} to="/"><i className="fa fa-home" aria-hidden="true"></i> User management [UM]</NavbarBrand>
                                <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                                <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>

                                    <ul className="navbar-nav flex-grow">
                                        <NavItem>
                                            <NavLink tag={Link} className="text-dark" to="/">Home</NavLink>
                                        </NavItem>

                                        <NavItem className="nav-item dropdown">
                                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="true" style={{ color: "black" }} >Application</a>
                                            <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink" >
                                                <NavLink className="text-dark" tag={Link} to="/application">Application</NavLink>
                                                <NavLink className="text-dark" tag={Link} to="/approver">Approver Setup</NavLink>
                                            </div>
                                        </NavItem>

                                        <NavItem className="nav-item dropdown">
                                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="true" style={{ color: "black" }} >User</a>
                                            <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink" >
                                                <NavLink className="text-dark" tag={Link} to="/userlist">User List</NavLink>
                                                <NavLink className="text-dark" tag={Link} to="/usergroups">User Groups</NavLink>
                                            </div>
                                        </NavItem>

                                        <NavItem className="nav-item dropdown">
                                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="true" style={{ color: "black" }} >Email</a>
                                            <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink" >
                                                <NavLink className="text-dark" tag={Link} to="/umemails">UM Emails</NavLink>
                                                <NavLink className="text-dark" tag={Link} to="/emailtemplate">Email Templates</NavLink>
                                            </div>
                                        </NavItem>

                                        <NavItem className="nav-item dropdown">
                                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="true" style={{ color: "black" }} >Tasks</a>
                                            <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink" >
                                                <NavLink className="text-dark" tag={Link} to="/workflowmonitor">Workflow Monitor</NavLink>
                                                <NavLink className="text-dark" tag={Link} to="/companyrequest">Company Request</NavLink>
                                                <NavLink className="text-dark" tag={Link} to="/updateemails">Update Email(s)</NavLink>
                                                <NavLink className="text-dark" tag={Link} to="/relatedapplication">Related Application</NavLink>
                                                <NavLink className="text-dark" tag={Link} to="/revalidationsetup">Revalidation Setup</NavLink>
                                                <NavLink style={{ width: "200px" }} className="text-dark" tag={Link} to="/approverdelegation">Approver Delegation</NavLink>
                                            </div>
                                        </NavItem>

                                        <NavItem className="nav-item dropdown">
                                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="true" style={{ color: "black" }} >Settings</a>
                                            <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink" >
                                                <NavLink className="text-dark" tag={Link} to="/metadata">Metadata</NavLink>
                                                <NavLink className="text-dark" tag={Link} to="/region">Region</NavLink>
                                                <NavLink className="text-dark" tag={Link} to="/country">Country</NavLink>
                                                <NavLink className="text-dark" tag={Link} to="/companytype">Company Type</NavLink>
                                                <NavLink className="text-dark" tag={Link} to="/company">Company</NavLink>
                                                <NavLink className="text-dark" tag={Link} to="/businessunit">Business Unit</NavLink>
                                                <NavLink className="text-dark" tag={Link} to="/officelocation">Office Location</NavLink>
                                            </div>
                                        </NavItem>


                                        <NavItem className="nav-item dropdown">
                                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="true" style={{ color: "black" }} ><i className="fas fa-user"></i> {data.loginUser.name}</a>
                                            <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink" >
                                                <NavLink style={{ marginLeft: "15Px" }} className="text-dark" tag={Link} to="#" onClick={data.logout}><i className="fas fa-sign-out-alt"></i>  Logout</NavLink>
                                            </div>
                                        </NavItem>
                                    </ul>
                                </Collapse>
                            </Navbar>

                            : <></>
                    }
                </AuthContext.Consumer>
            </header>
        );
    }
}
